export enum RepairabilityEnum {
  YES = 'YES',
  NO = 'NO',
  NA = 'NA'
}
